export default __webpack_public_path__ + "static/media/Snd_CM.e38fa17e.mp3";